import { Box, Text } from '@chakra-ui/react';
import React from 'react';
import CardStack from './components/cardStack';

const HomePage = () => {
  return (
    <Box
      mt={40}
      mx={{ base: '2', md: '20', lg: '32' }}>
      {/* <Text
        mb={12}
        align='center'
        fontSize='4xl'
        fontWeight='light'>
        Summary
      </Text> */}
      <CardStack />
    </Box>
  );
};

export default HomePage;
